import React from 'react';
import { Check, X, Minus } from 'lucide-react';
const rows = [{
  situation: 'Comprendes el sistema',
  without: true,
  with: true
}, {
  situation: 'Interpretación sin manual',
  without: false,
  with: true
}, {
  situation: 'Combinar cartas con fluidez',
  without: false,
  with: true
}, {
  situation: 'Desarrollo de intuición',
  without: 'partial',
  with: true
}, {
  situation: 'Preguntas poderosas',
  without: false,
  with: true
}, {
  situation: 'Lecturas reales paso a paso',
  without: false,
  with: true
}, {
  situation: 'Rituales de conexión',
  without: false,
  with: true
}, {
  situation: 'Confianza desde el día 1',
  without: false,
  with: true
}];
export function ComparisonTable() {
  return <section className="px-5" data-id="element-60">
      <div className="max-w-xl mx-auto" data-id="element-61">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-brand-petroleum mb-16 tracking-tight" data-id="element-62">
          La diferencia es clara
        </h2>

        <div className="bg-white rounded-[32px] overflow-hidden shadow-premium border border-brand-petroleum/5" data-id="element-63">
          <div className="grid grid-cols-3 text-center text-[10px] font-bold uppercase tracking-widest border-b border-brand-petroleum/5" data-id="element-64">
            <div className="p-6 text-brand-medium-grey bg-brand-soft-cream/30" data-id="element-65">
              Situación
            </div>
            <div className="p-6 text-brand-medium-grey" data-id="element-66">Tradicional</div>
            <div className="p-6 text-brand-gold-warm bg-brand-gold-warm/5" data-id="element-67">
              Tarot Listo
            </div>
          </div>
          {rows.map((row, idx) => <div key={idx} className="grid grid-cols-3 text-center border-b border-brand-petroleum/5 last:border-b-0" data-id="element-68">
              <div className="p-6 text-[11px] font-bold text-brand-petroleum flex items-center justify-center bg-brand-soft-cream/30 leading-tight" data-id="element-69">
                {row.situation}
              </div>
              <div className="p-6 flex items-center justify-center" data-id="element-70">
                {row.without === true ? <Check size={18} className="text-brand-sage-green opacity-40" data-id="element-71" /> : row.without === 'partial' ? <Minus size={18} className="text-brand-medium-grey opacity-40" data-id="element-72" /> : <X size={18} className="text-red-300" data-id="element-73" />}
              </div>
              <div className="p-6 bg-brand-gold-warm/5 flex items-center justify-center" data-id="element-74">
                <Check size={20} className="text-brand-gold-warm" data-id="element-75" />
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-76">
          <p className="text-brand-medium-grey font-medium text-sm leading-relaxed max-w-md mx-auto italic" data-id="element-77">
            La pregunta no es si el sistema completo tiene más valor. Eso es
            evidente.
          </p>
          <p className="text-brand-petroleum font-bold text-base mt-4" data-id="element-78">
            ¿Querés solo mirar las cartas con dudas… o realmente empezar a
            interpretarlas con confianza?
          </p>
        </div>
      </div>
    </section>;
}